import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DynamicFormContainer from "./UI/DynamicFormContainer";
import { PatientConfirmationPageContainer } from "./UI/screens/confirmationPage/PatientConfirmationPageContainer";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { instkey } from "./config/Constants";
import "./App.scss";

// Helper to get the session token from cookies (requires cookie not be HttpOnly)
const getSessionFromCookie = () => {
    const cookieString = document.cookie;
    const cookies = cookieString.split(';');
    const sessionCookie = cookies.find(cookie => cookie.trim().startsWith("SessionToken="));
    return sessionCookie ? sessionCookie.split('=')[1] : null;
};

// the session token comes from the web server when fetching https://vra.verisma.com/api/{formid}
// this will store the token if it's a new one
// or fetching the stored token if there is one that's stored.
const getTabSessionToken = () => {
    let token = sessionStorage.getItem("SessionToken");
    let cookietoken = getSessionFromCookie();

    if (window.location.origin.includes('app-vra.azurewebsites.net') || window.location.origin.includes('app-vra-test') || window.location.origin.includes('localhost')) {
        if (token) {
            console.log("Session Token:" + token);
        } else { console.log("Session token is null"); }

        if (cookietoken) {
            console.log("Cookie Token:" + cookietoken);
        } else { console.log("Cookie token is null"); }
        console.log(document.referrer);
    }

    if (cookietoken && cookietoken !== token) {
        sessionStorage.setItem("SessionToken", cookietoken);
        return cookietoken;
    }

    return token;
};

const appInsights = new ApplicationInsights({ config: { instrumentationKey: instkey } });
appInsights.loadAppInsights();
appInsights.trackPageView();

const App = () => {
    // Use the tab-specific token from sessionStorage (or cookie if not yet stored)
    const session = {
        id: getTabSessionToken(), // Uses the API's session token, saved per tab in sessionStorage.
        form: 1,
    };

    //<Route path="/" component={HomePage} exact />
    //with this:

    //<Route path="/" element={<HomePage />} exact />


    return (
        <Router basename={"/patient"}>
            <div className="app">
                <Routes>
                    <Route path="/" element={ <DynamicFormContainer session={session} />} exact />
                    <Route path="/patientConfirmationPage" element={<PatientConfirmationPageContainer session={session} />} />
                </Routes>
            </div>
        </Router>
    );
};

export default App;